import SegmentedControl from '../app/design/SegmentedControl'
import { CurrencyField } from './fields/CurrencyField'
import { SearchableSelect } from './fields/SearchableSelect'
import { SelectOption } from '../settings/Options'

type RateType = 'rate' | 'percent'

type Props = {
    amount: number
    rateType: RateType
    rateOptions: SelectOption[]
    onChange: (rateType: RateType, amount: number) => void
}

export const RatePicker = ({ amount, rateType, rateOptions, onChange }: Props) => {
    const onChangeSegment = (value: string) => {
        onChange(value === 'rate' ? 'rate' : 'percent', 0)
    }

    return (
        <div className="flex flex-col gap-y-2">
            <div className="flex items-center gap-x-2">
                <SegmentedControl
                    size="medium"
                    className="w-[304px] shrink-0"
                    segments={[
                        { label: 'Fixed amount', value: 'rate' },
                        { label: 'Percent of total', value: 'percent' },
                    ]}
                    value={rateType}
                    onChange={onChangeSegment}
                />
                <div className="min-w-0 shrink grow border-gray-500">
                    {rateType === 'percent' ? (
                        <SearchableSelect
                            size="medium"
                            className="m-0 h-12"
                            items={rateOptions.map((option) => ({
                                id: option.value,
                                title: option.label,
                            }))}
                            onSelectItem={(item) =>
                                item !== null
                                    ? onChange(rateType, Number(item.id))
                                    : onChange(rateType, 0)
                            }
                            selectedItemID={amount === 0 ? '' : amount?.toString()}
                            shouldPreserveLastSelection
                        />
                    ) : (
                        <CurrencyField
                            size="medium"
                            className="m-0 h-12"
                            placeholder="Select number"
                            value={amount}
                            onChange={(value) => onChange(rateType, value ?? 0)}
                            type="number"
                            min={0}
                            step={0.01}
                            prefix="$"
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
